import { ChevronRight } from "lucide-react";

const ITEMS = [
  "Dedicated Bakkie Fleet",
  "9 Provinces Running",
  "B2B Last-Mile Capacity",
  "Contracted Overflow Relief",
  "POD on Every Manifest",
  "Parcel Delivery Operations",
];

export const Marquee = () => (
  <section
    className="overflow-hidden border-y border-white/10 bg-[#0D1424] py-5"
    aria-label="Contract capabilities"
  >
    <div className="animate-marquee flex w-max">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span
              key={`${copy}-${item}`}
              className="flex items-center font-display text-lg font-extrabold uppercase tracking-tight text-slate-500 md:text-2xl"
            >
              <span className="whitespace-nowrap px-6 md:px-8">{item}</span>
              <ChevronRight className="h-5 w-5 shrink-0 text-[#FF6B00]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
